import { ReactNode } from 'react';
import clsx, { ClassValue } from 'clsx';
import styles from '../DocumentListItem.module.scss';

export type TreeItemColumnName = 'status' | 'version' | 'date' | 'sign';

export const columnClass = (
  hiddenColumns: string[],
  column: TreeItemColumnName,
  ...extra: ClassValue[]
) =>
  clsx(styles.column, extra, {
    [styles.columnHidden]: hiddenColumns.includes(column),
  });

type TreeItemColumnProps = {
  column: TreeItemColumnName;
  hiddenColumns: string[];
  className?: string;
  testId?: string;
  children?: ReactNode;
};

/** Generic column component for a tree item. */
export const TreeItemColumn = ({
  column,
  hiddenColumns,
  className,
  testId,
  children,
}: TreeItemColumnProps) => (
  <div
    data-test-id={testId}
    className={columnClass(hiddenColumns, column, className)}
  >
    {children}
  </div>
);
